import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

const EmptyWrapper = styled.div(({ theme }) => ({
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, 0)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "1.6rem",
  justifyContent: "center",

  ".text": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: theme.color.light_gray,
    fontWeight: theme.fontWeight.medium,
    lineHeight: "2rem",
  },

  ".text span": {
    whiteSpace: "nowrap",
  },
}));

type Props = {
  type: "product" | "brand" | "seller";
};
const EmptyText = ({ type }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const lang = window.localStorage.getItem("language");
  return (
    <EmptyWrapper>
      <Image
        src={theme.image.love_icon.default}
        width="3.2rem"
        height="3.2rem"
      />

      <div className="text">
        {type === "product" && (
          <span>{t("좋아요를 눌러 관심있는 상품을")}</span>
        )}
        {type === "product" && lang === "ko" && <span>한눈에 보세요</span>}

        {type === "brand" && (
          <span>{t("좋아요를 눌러 관심있는 브랜드를")}</span>
        )}
        {type === "brand" && lang === "ko" && <span>한눈에 보세요</span>}

        {type === "seller" && (
          <span>{t("좋아하는 셀러를 팔로우해 소식을")}</span>
        )}
        {type === "seller" && lang === "ko" && <span>받아보세요</span>}
      </div>
    </EmptyWrapper>
  );
};

export default EmptyText;
